import { createTheme } from '@mui/material/styles';
import { themeOptions } from './tokens.js';

/**
 * MUI theme for the ported Efforts / Field Sales dashboards.
 *
 * The source app wrapped every page in a ThemeProvider built from
 * `themeOptions` (Poppins font, denser table cells, 10px button radius...).
 * This host app has no global MUI theme, so the dashboards scope the same
 * theme to their own subtree through `DashboardThemeProvider`.
 *
 * `MuiCssBaseline` overrides are dropped on purpose: they style `html`, `body`
 * and `*` globally and would leak into the rest of the app. The red scrollbars
 * they provided are reproduced, scoped to `.dk-root`, in `../tokens.css`.
 */
const { MuiCssBaseline: _globalBaseline, ...scopedComponents } = themeOptions.components;

export const dashboardTheme = createTheme({
  ...themeOptions,
  components: scopedComponents,
});

export default dashboardTheme;
